import { useAuth } from '../auth/AuthContext';

export function CallbackPage() {
  const { loading } = useAuth();
  return (
    <div className="min-h-screen flex items-center justify-center text-ink-800">
      {loading ? 'Completing sign-in…' : 'Redirecting…'}
    </div>
  );
}
